export const copy = {
  en: {
    hero: {
      label: "MANAGEMENT · STRATEGY · VENTURES",
      body: "DEALER is a management, strategy and ventures company representing exceptional people and brands, and creating new opportunities, campaigns, projects and strategic partnerships.",
      cta: "DISCOVER DEALER",
    },
    philosophy: {
      body: "The most valuable opportunities are rarely waiting to be found. They are created through the right positioning, relationships and ideas.",
    },
    representation: {
      p1: "DEALER represents exceptional people and brands, creating new opportunities around their potential, influence and long-term value.",
      p2: "For us, representation is not simply about managing what already exists. We bring talent, brands and ideas together to create new partnerships, campaigns and projects.",
    },
    talent: {
      body: "World Champion Daniele Santarelli is one of international volleyball’s most accomplished and respected coaches. His career combines success at the highest level with a Guinness World Record of 76 consecutive victories. Today, he also shares his experience through leadership and motivational speaking. DEALER is proud to represent Daniele Santarelli.",
    },
    strategic: {
      body: "DEALER operates beyond traditional representation and management — creating opportunities, partnerships, campaigns and projects where people, brands and ideas can create greater long-term value together.",
      areas: [
        "REPRESENTATION",
        "BRAND PARTNERSHIPS",
        "STRATEGIC POSITIONING",
        "COMMERCIAL NEGOTIATIONS",
        "OPPORTUNITY & PROJECT DEVELOPMENT",
        "INTERNATIONAL RELATIONSHIPS",
      ],
    },
    contact: {
      sub: "For representation, brand partnerships, projects and strategic opportunities.",
      name: "NAME",
      email: "EMAIL",
      company: "COMPANY",
      message: "MESSAGE",
      submit: "START A CONVERSATION",
      sending: "SENDING…",
      successTitle: "RECEIVED.",
      successBody: "Thank you. We’ll be in touch.",
      error: "Something went wrong. Please try again.",
    },
  },
  tr: {
    hero: {
      label: "MANAGEMENT · STRATEGY · VENTURES",
      body: "DEALER; olağanüstü insanları ve markaları temsil eden, yeni fırsatlar, kampanyalar, projeler ve stratejik iş birlikleri yaratan bir yönetim ve strateji şirketidir.",
      cta: "DEALER'I KEŞFET",
    },
    philosophy: {
      body: "En değerli fırsatlar çoğu zaman keşfedilmeyi beklemez. Doğru konumlandırma, doğru ilişkiler ve doğru fikirlerle yaratılır.",
    },
    representation: {
      p1: "DEALER, olağanüstü insanları ve markaları temsil eder; potansiyelleri, etkileri ve uzun vadeli değerleri etrafında yeni fırsatlar yaratır.",
      p2: "Temsil bizim için yalnızca var olanı yönetmek değildir. Yetenekleri, markaları ve fikirleri bir araya getirerek yeni iş birlikleri, kampanyalar ve projeler yaratırız.",
    },
    talent: {
      body: "Dünya Şampiyonu Daniele Santarelli, uluslararası voleybolun en başarılı ve saygın antrenörlerinden biridir. Kariyerinde, en üst düzeyde kazandığı şampiyonlukların yanı sıra 76 maçlık galibiyet serisiyle kırdığı Guinness Dünya Rekoru da bulunuyor. Bugün deneyimlerini liderlik ve motivasyon konuşmalarıyla da paylaşıyor. DEALER, Daniele Santarelli’yi temsil etmekten gurur duyar.",
    },
    strategic: {
      body: "DEALER, geleneksel temsil ve yönetimin ötesinde çalışır. İnsanların, markaların ve fikirlerin bir araya gelerek daha büyük ve uzun vadeli değer yaratabileceği fırsatlar, iş birlikleri, kampanyalar ve projeler geliştirir.",
      areas: [
        "TEMSİL",
        "MARKA İŞ BİRLİKLERİ",
        "STRATEJİK KONUMLANDIRMA",
        "TİCARİ MÜZAKERELER",
        "FIRSAT VE PROJE GELİŞTİRME",
        "ULUSLARARASI İLİŞKİLER",
      ],
    },
    contact: {
      sub: "Temsil, marka iş birlikleri, projeler ve stratejik fırsatlar için bizimle iletişime geçin.",
      name: "AD SOYAD",
      email: "E-POSTA",
      company: "ŞİRKET",
      message: "MESAJ",
      submit: "İLETİŞİME GEÇ",
      sending: "GÖNDERİLİYOR…",
      successTitle: "ALINDI.",
      successBody: "Teşekkür ederiz. En kısa sürede sizinle iletişime geçeceğiz.",
      error: "Bir sorun oluştu. Lütfen tekrar deneyin.",
    },
  },
  it: {
    hero: {
      label: "MANAGEMENT · STRATEGY · VENTURES",
      body: "DEALER è una società di management, strategia e ventures che rappresenta persone e brand d’eccellenza, creando nuove opportunità, campagne, progetti e partnership strategiche.",
      cta: "SCOPRI DEALER",
    },
    philosophy: {
      body: "Le opportunità di maggior valore raramente aspettano di essere scoperte. Nascono dal giusto posizionamento, dalle relazioni giuste e dalle idee giuste.",
    },
    representation: {
      p1: "DEALER rappresenta persone e brand d’eccellenza, creando nuove opportunità attorno al loro potenziale, alla loro influenza e al loro valore nel lungo periodo.",
      p2: "Per noi, rappresentare non significa semplicemente gestire ciò che già esiste. Mettiamo in relazione talenti, brand e idee per dare vita a nuove partnership, campagne e progetti.",
    },
    talent: {
      body: "Campione del mondo, Daniele Santarelli è uno degli allenatori più affermati e rispettati della pallavolo internazionale. La sua carriera unisce successi ai massimi livelli a un Guinness World Record ottenuto grazie a una straordinaria serie di 76 vittorie consecutive. Oggi condivide la sua esperienza anche attraverso interventi dedicati alla leadership e alla motivazione. DEALER è orgogliosa di rappresentare Daniele Santarelli.",
    },
    strategic: {
      body: "DEALER opera oltre i confini della rappresentanza e del management tradizionali, creando opportunità, partnership, campagne e progetti in cui persone, brand e idee possano generare insieme un valore maggiore e duraturo.",
      areas: [
        "RAPPRESENTANZA",
        "PARTNERSHIP CON I BRAND",
        "POSIZIONAMENTO STRATEGICO",
        "NEGOZIAZIONI COMMERCIALI",
        "SVILUPPO DI OPPORTUNITÀ E PROGETTI",
        "RELAZIONI INTERNAZIONALI",
      ],
    },
    contact: {
      sub: "Per rappresentanza, partnership con i brand, progetti e opportunità strategiche.",
      name: "NOME E COGNOME",
      email: "EMAIL",
      company: "AZIENDA",
      message: "MESSAGGIO",
      submit: "INIZIA UNA CONVERSAZIONE",
      sending: "INVIO IN CORSO…",
      successTitle: "RICEVUTO.",
      successBody: "Grazie. Ti contatteremo al più presto.",
      error: "Si è verificato un problema. Riprova.",
    },
  },
};
